
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/antara/api/rogue",
      function () {
        return require("private-next-pages/en/docs/antara/api/rogue/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/antara/api/rogue"])
      });
    }
  